export function extractErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object') {
    const err = error as Record<string, any>;

    if (err?.response?.data?.message) {
      return err.response.data.message;
    }

    if (typeof err.message === 'string' && err.message.trim()) {
      return err.message;
    }

    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }
  }

  return fallback;
}